import { identity } from "../../../lib/utils/Identity.js";
import { VideoInfoRawData } from "../../../model/video/VideoInfo.js";
import { VideoRef } from "../../player/MediaResource.js";
import { AdCallParams } from "../AdCallParams.js";
import { AdUnit } from "../AdUnit.js";
import { AdParamsEnricher, PrebidModule } from "./PrebidModule.js";
import { PrebidModuleWithAdsManagerOps, isPrebidModuleWithAdsManagerOps } from "./PrebidModuleWithAdsManagerOps.js";



export class GroupedPrebidModules implements PrebidModule {

    protected modules: PrebidModule[];

    constructor() {
        this.modules = [];
    }

    public addModule(p: PrebidModule): void {
        this.modules.push(p);
    }

    load(): Promise<void> {
        return Promise.all(this.modules.map(mod => mod.load())).then();
    }

    bidAndGetEnricher(adUnit: AdUnit, info: VideoInfoRawData): Promise<AdParamsEnricher> {
        if(this.modules.length > 0) {
            return Promise.all(this.modules.map(mod => mod.bidAndGetEnricher(adUnit,info))).
                then(enrichers => {
                    return (params: AdCallParams) => {
                        return enrichers.reduce((prevParam,enricher) => enricher(prevParam),params)
                    }
                }).catch(e => {
                    console.log("HB-GROUPED error", e);
                    return Promise.resolve(identity);
                })
        }
        else return Promise.resolve(identity);
    }

}


export class GroupedPrebidModulesWithAdsManagerPostOps extends GroupedPrebidModules implements PrebidModuleWithAdsManagerOps {


    constructor() {
        super();
    }


    beforeAdManagerStart(g: typeof google, adUnit: AdUnit, adsManager: google.ima.AdsManager, resource: VideoRef): Promise<void> {
        if(this.modules.length > 0)     {
            return Promise.all(this.modules.map(mod => {
                if(isPrebidModuleWithAdsManagerOps(mod)) {
                    return mod.beforeAdManagerStart(g,adUnit,adsManager,resource);
                }
                else return Promise.resolve();
            })).then();
        }
        else return Promise.resolve();
    }

}